import React from 'react';
import { NavLink } from 'react-router-dom';
import ADMIN_PATHS from '../../ADMIN_PATHS';

const ACCENT = '#D2042D';

const menuItems = [
  {
    path: ADMIN_PATHS.ADMIN.BASE,
    label: 'Admin List',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
      </svg>
    ),
  },
  {
    path: ADMIN_PATHS.ADMIN.ROLES,
    label: 'Roles & Permissions',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 17v-2a4 4 0 014-4h4m-6 6v2a2 2 0 002 2h4a2 2 0 002-2v-2m-6 0h6" />
      </svg>
    ),
  },
  {
    path: ADMIN_PATHS.ADMIN.SECURITY,
    label: 'Security',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 11c0-1.657 1.343-3 3-3s3 1.343 3 3v2a3 3 0 01-3 3h-2a3 3 0 01-3-3v-2z" />
      </svg>
    ),
  },
  {
    path: ADMIN_PATHS.ADMIN.ACTIVITY,
    label: 'Activity Logs',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h1l2 9h13l2-9h1" />
      </svg>
    ),
  },
  {
    path: ADMIN_PATHS.ADMIN.CREATE,
    label: 'Create Admin',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
      </svg>
    ),
  },
];

const RoleMenu = () => (
  <header className="sticky top-0 z-40 border-b border-slate-200 bg-white/85 backdrop-blur">
    <div className="mx-auto px-4 md:px-6 py-3">
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-center gap-2 min-w-0">
          <span className="h-4 w-[3px] rounded-full" style={{ background: ACCENT }} aria-hidden="true" />
          <h1 className="text-base md:text-lg font-black tracking-tight text-slate-900 truncate">
            Admin & Role Management
          </h1>
        </div>
      </div>

      <nav className="mt-3 -mx-1 px-1 overflow-x-auto">
        <div className="flex items-center gap-2 whitespace-nowrap">
          {menuItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                [
                  'inline-flex items-center gap-2 rounded-full border px-3 py-2 text-sm font-semibold transition-colors',
                  'focus:outline-none focus-visible:ring-2 focus-visible:ring-[#D2042D]/30',
                  isActive
                    ? 'border-[#D2042D]/20 bg-[#D2042D]/10 text-[#D2042D]'
                    : 'border-slate-200 bg-white text-slate-700 hover:border-slate-300 hover:bg-slate-50',
                ].join(' ')
              }
            >
              <span className="shrink-0">{item.icon}</span>
              <span className="truncate">{item.label}</span>
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  </header>
);

export default RoleMenu;
